"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToastProvider = exports.ToastContext = void 0;
const react_1 = __importStar(require("react"));
const Toast_1 = __importDefault(require("react-bootstrap/Toast"));
const react_bootstrap_1 = require("react-bootstrap");
const ToastContext = (0, react_1.createContext)(null);
exports.ToastContext = ToastContext;
const ToastProvider = ({ children }) => {
    const [show, setShow] = (0, react_1.useState)(false);
    const [type, setType] = (0, react_1.useState)("");
    const [title, setTitle] = (0, react_1.useState)("");
    const [message, setMessage] = (0, react_1.useState)("");
    const toggleToast = () => setShow(!show);
    const showToast = (type, title, message, time) => {
        setShow(true);
        setType(type);
        setTitle(title);
        setMessage(message);
        setTimeout(() => (setShow(false)), time || 3000);
    };
    const ToastService = {
        show,
        showToast
    };
    return (react_1.default.createElement(ToastContext.Provider, { value: ToastService },
        children,
        react_1.default.createElement(react_bootstrap_1.ToastContainer, { position: "top-end", className: "mt-5 me-4 toast-container" },
            react_1.default.createElement(Toast_1.default, { show: show, onClose: toggleToast, typeof: type },
                react_1.default.createElement(Toast_1.default.Header, null,
                    react_1.default.createElement("div", { className: "pointer " + type }),
                    react_1.default.createElement("strong", { className: "me-auto" }, title)),
                react_1.default.createElement(Toast_1.default.Body, null, message)))));
};
exports.ToastProvider = ToastProvider;
